import axios from 'axios';
import type { AxiosResponse, AxiosError } from 'axios';
import { modelToDto } from './mapper';
import type {
  VerifyEmailSubmitDataModel,
  VerifyEmailErrorResponseDto,
  VerifyEmailSuccessResponseDto,
  VerifyEmailRequestDto,
  VerifyEmailCodeDataModel,
  VerifyEmailCodeResponseDto,
} from './model';

export async function verifyEmail(
  payload: VerifyEmailSubmitDataModel,
): Promise<AxiosResponse<VerifyEmailSuccessResponseDto> | AxiosError<VerifyEmailErrorResponseDto>> {
  const response = await axios.post<
    VerifyEmailRequestDto,
    AxiosResponse<VerifyEmailSuccessResponseDto> | AxiosError<VerifyEmailErrorResponseDto>
  >('/api/v1/verify-email', modelToDto(payload));

  return response;
}

export async function verifyEmailCode(
  payload: VerifyEmailCodeDataModel,
): Promise<AxiosResponse<VerifyEmailCodeResponseDto> | AxiosError<VerifyEmailCodeResponseDto>> {
  const response = await axios.get(`/api/v1/verify-email?code=${payload.code}&vid=${payload.vid}`);

  return response;
}
